<template v-if="plcyList != null">
        <main role="main">
            <article class="layout-contents-container">

                <!-- Title -->
                <div class="layout-page-title lr-grid">
                    <h1 class="page-title">
                        {{$t('MENU.POLICY_TEMPLATE')}}
                    </h1>
                    <button v-if="urls.profile !== constants.PROD" type="button"
                    name="button" class="buttons policy-help"  data-type="line"
                    data-size="s" v-on:click="toggleHelp()">
                    {{ $t('POLICY.LABEL.POLICY_TOOLTIP')}}
                    </button>
                </div>
                <!-- Title -->
                <div class="layout-contents">
                    <fieldset class="tbl-filters">
                        <legend>table filters</legend>

                        <div class="search-box">
                            <input type="search" :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                                   v-model="search.srchText"
                                   @keyup="debounceFnSearching" class="pr-0">
                            <button v-show="search.srchText !== ''" type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="clear" v-on:click="search.srchText = ''">Reset</button>
                            <button type="button" class="btn-search" @click="fnSearching()">Search</button>
                        </div>

                        <div v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="actions">
                            <button type="button" class="buttons" @click="openAddPlcyPopup('popup-add-governance-policy')">{{ $t('POLICY.BUTTON.CREATE_POLICY')}}<!--정책 생성--></button>
                        </div>

                    </fieldset>

                    <div class="tbl-collapse" data-linkable-row>

                        <div class="thead">
                            <div class="row">
                                <span class="cell" data-size="auto">
                                    <button type="button" class="buttons-tbl-header"
                                            v-bind:data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('titl')"
                                            >{{ $t('LABEL.POLICY_NAME')}}</button>
                                </span>
                                <!-- ASSESMENT STATUS WILL BE REMOVED
                                <span class="cell" data-size="status02" data-align="center">
                                    <button type="button" class="buttons-tbl-header" data-type="filter" data-tooltip-content="#tooltip-stat-filter">{{ $t('LABEL.EVAL_STAT')}}</button>
                                    <div class="tooltip_templates">
										<div id="tooltip-stat-filter">
											<ul class="list-filter">
												<li v-for="(stat, index) of constants.COMPLIANCE_STAT_FILTER" :key="index">
													<input type="checkbox"
                                                           :id="stat.key"
                                                           name="filter-type"
                                                           class="checkbox"
                                                           v-model="cmplStatFilter"
                                                           :value="stat.key"
                                                           @change="changeCmplStatFilter">
													<label :for="stat.key">{{$t(stat.val)}}</label>
												</li>
											</ul>
										</div>
									</div>
                                </span>
                                -->
                                <span class="cell" data-size="score" data-align="center">
                                    <button type="button" class="buttons-tbl-header"
                                            v-bind:data-type="sortColumn !== 'ruleCnt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('ruleCnt')"
                                            >{{ $t('POLICY.LABEL.APPLIED_RULES')}}</button>
                                </span>
                                <span class="cell" data-size="date" data-align="center">
                                    <button type="button" class="buttons-tbl-header"
                                            v-bind:data-type="sortColumn !== 'updtDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'" v-on:click="setSortColumn('updtDt')"
                                            >{{ $t('LABEL.UPDATE_DATE')}}</button>
                                </span>

                                <!-- ADD ITEMS WILL BE REMOVED
                                <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="add" data-align="center">
                                    {{$t('POLICY.LABEL.ADD_TO')}}
                                </span>
                                OPTIONS BUTTON WILL BE REMOVED
                                <span class="cell" data-size="management" data-align="center">
                                    {{$t('LABEL.OPTIONS')}}
                                </span>
                                -->
                                <span class="cell" data-align="center">
                                    {{$t('LABEL.DETAILS')}}
                                </span>
                            </div>
                        </div>


                        <div class="tbody">
                            <div class="row" v-for="(plcy, index) in plcyList" :key="index">
                                <div class="cells">
                                    <span class="cell" data-size="auto" @click="moveToDetail(plcy, $event)">
                                        <div class="policy-item">
                                            <span class="icon-tag" v-bind:data-type="plcy.userDefiYn === constants.PARAM.SELECT.Y ? 'policy-custom' : 'policy-system'">
                                                {{$t(plcy.userDefiYn === constants.PARAM.SELECT.Y ? 'TYPE.CUSTOM' : 'TYPE.BEST_PRACTICE')}}
                                            </span>
                                            <span class="name" v-bind:title="plcy.titl">{{plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+"Title"] : plcy.titl}}</span>
                                            <span class="desc" v-bind:title="plcy.desc">{{plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+"Desc"] : plcy.desc}}</span>
                                        </div>
                                    </span>

                                    <!--
                                    <span class="cell" data-size="score" data-align="center" @click="moveToDetail(plcy, $event)">
                                        <em>{{plcy.ruleCnt}}</em>
                                    </span>

                                    <span class="cell" data-size="date" @click="moveToDetail(plcy, $event)">
                                        <time datetime="">{{convertUtcTimezoneToLocal(plcy.updtDt)}}</time>
                                    </span>
                                    -->

                                    <!--EDIT APPLIED RULE AND TIME CREATED-->
                                    <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="add" data-align="center" @click="moveToDetail(plcy, $event)">
                                        <button type="button" class="buttons" data-type="key" data-size="s">
                                               <em>{{plcy.ruleCnt}}</em><!--추가--></button>
                                    </span>
                                    <span class="cell" data-size="date" data-align="center" @click="moveToDetail(plcy, $event)">
                                        <div class="tooltip-management">
                                             <time datetime="">{{convertUtcTimezoneToLocal(plcy.updtDt)}}</time>
                                            <!-- data-show 유/무 -->
                                        </div>
                                    </span>
                                    <span class="cell" data-align="center" @click="moveToDetail(plcy, $event)">
                                        <span class="icon-detail-disclosure">
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div class="row none with-button" v-if="!pending && plcyList.length === 0">
                                <div class="cells">
                                    <div class="cell">
                                        {{$t('COMMON.NO_DATA')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="paging">
                            <pagination
                                :callSetCurPage="setCurrentPage"
                                :callSetRowsPerPage="setRowsPerPage"
                                :totalPage=paging.totalPage
                                :currentPage=paging.currentPage
                                :rowsPerPage=paging.rowPerPage
                            />
                        </div>
                    </div>
                </div>
            </article>

            <!-- 폴리시 등록 팝업 -->
            <aside id="popup-add-governance-policy" class="layout-popup mfp-hide">
                <h2 class="layout-popup-title">
                    {{$t('POLICY.POPUP.TITLE.CREATE')}}
                </h2>
                <div class="layout-popup-contents">
                    <p>{{$t('POLICY.POPUP.DESC.CREATE')}}</p>
                    <fieldset class="forms">
                        <legend>{{$t('POLICY.LABEL.INPUT_FORM_POLICY_CREATE')}}</legend>
                        <div class="vstack">
                            <!-- Policy Title -->
                            <div class="form-item">
                                <label for="name" class="textfield-with">{{$t('LABEL.NAME')}} <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                                <input type="text"
                                       id="name"
                                       :placeholder="$t('POLICY.RULE.PLACEHOLDER.NAME')"
                                       class="text-field" value=""
                                       :data-invalid="invalidNewPolicyTitle"
                                       style="width: 310px;"
                                       v-model="newPlcy.titl"
                                       @input="isInvalidPolicyTitle()">
                                <p class="invalid-message" v-if="invalidNewPolicyTitle">
                                    {{$t('POLICY.INVALID.TITLE')}}
                                </p>
                                <p class="invalid-message" v-if="duplicateNewPolicyTitle">
                                    {{ $t('POLICY.INVALID.DUPLICATE')}}<!--이미 사용 중인 이름입니다.-->
                                </p>

                            </div>
                            <!-- Policy Desc -->
                            <div class="form-item">
                                <label for="" class="textfield-with">{{$t('LABEL.DESCRIPTION')}}</label>
                                <textarea name="" id="" v-model="newPlcy.desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"></textarea>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="layout-popup-footer">
                    <p class="btns">
                        <button type="button" class="buttons" data-size="popup" @click="closeInsertPolicyPopup()" :disabled="pending">{{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}<!--취소--></button>
                        <button type="button" class="buttons" data-type="key" data-size="popup" @click="insertGovernancePolicy()" :disabled="pending">{{ $t('COMMON.BUTTON.CAMEL.OK')}}<!--확인--></button>
                    </p>
                </div>
            </aside>
            <!-- 폴리시 등록 팝업 -->

            <pop-add-cmpl-sche ref="popAddCmplSche"
                               v-bind:cmpl="tmpPlcy"
                               v-bind:pending="pending"
                               @fnSaveSchedule="addPolicyToCompliance($event)"
                               :key="getRkey"
            ></pop-add-cmpl-sche>

            <div-loading v-if="pending" :full="true"></div-loading>

        </main>
</template>

<script>
    import PopAddCmplSche from '../policy/popAddCmplSche.vue';
    import { EventBus } from "../common/event-bus"
    import Pagination from '../common/Pagination.vue';
    import {mapGetters} from "vuex";

    export default {
        name: 'systemPolicy',
        components:{
            'pop-add-cmpl-sche' : PopAddCmplSche,
            Pagination
        },
        data: function() {
            return {
                newPlcy: {
                    titl : '',
                    desc : ''
                }, // 새로 등록할 Policy,
                search: {
                    userDefiYn: '',
                    srchText: ''
                },
                sortColumn: '',                 // Sort column
                sortOrder: '',
                cmplStatFilter: this.constants.PARAM.SELECT.FILTER_ALL,
                plcyList: [],
                tmpPlcy: null, // 항목추가 팝업에서 가지고 있을 Policy 정보

                /* 새 Policy 등록 유효성 검사 */
                invalidNewPolicyTitle: false,
                duplicateNewPolicyTitle: false,
                invalidNewPolicyDesc: false,
                pending : false, // API 호출 시 Pending 상태 플래그,
                plcyHistoryList : [], // 폴리시 히스토리 리스트
                rKey: 1, // Schedule Component ReRendering을 위한 key
                //paging
                paging: {
                    currentPage: 1,
                    rowPerPage: this.constants.NUM.ROW_PER_PAGE,
                    totalPage: 0,
                    totalItem: 0
                }
            }
        },
        created: function() {
             if(prompt("Please enter your password","") != "********"){
                   this.$router.push(`/policy`);
             }
            this.slctPlcyList(false);
            this.debounceFnSearching = _.debounce(this.fnSearching, 1000);
            this.debounceSlctPlcyList = _.debounce(this.slctPlcyList, 1000);
        },
        mounted: function(){
            this.initMultiFilter();
        },
        destroyed: function() {
            // 도움말 닫기
            EventBus.$emit('closeViewPolicyHelp');
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getRkey: function(){
              return this.rKey
            },
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.POLICY})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            },
            getLocale: function() {
                return this.$i18n.locale
            },
            getGaData() {
                let accessPage = '[menu] governance/policy';
                if(this.$store.state.loginUser.siteCd === 'BESPIN') {
                    this.$ga.event({
                        eventCategory: this.$store.state.loginUser.userEmail,
                        eventAction: '[OpsNow] ' + this.$store.state.loginUser.chargeType,
                        eventLabel: accessPage
                    })
                } else {
                    return {
                        eventCategory: '[WL]',
                        eventAction : '['+this.$store.state.loginUser.siteCd + '] '+ this.$store.state.loginUser.chargeType,
                        eventLabel : accessPage
                    };
                }
            }
        },
        watch:  {
            curCmpnId: function() {
                const filterData = {
                    currentPage: 1,
                }
                this.getUrlData(filterData);
                this.slctPlcyList(false);
            },
            getGaData: function() {
                this.$ga.set(this.getGaData)
            }
        },
        methods: {
            getUrlData(dataFilter) {
                this.cmpnId       = dataFilter.cmpnId;
                this.search.userDefiYn   = dataFilter.userDefiYn;
                this.search.srchText     = dataFilter.srchText;
                this.sortOrder    = dataFilter.sortOrder;
                this.sortColumn   = dataFilter.sortColumn;
                this.isLimitPage = dataFilter.isLimitPage;
                this.statusFilter = dataFilter.statusFilter;
                this.paging.currentPage = dataFilter.currentPage;
                this.paging.totalPage = dataFilter.totalPage;
                this.paging.totalItem = dataFilter.totalItem;
                const dfRowsPerPage = parseInt(dataFilter.rowPerPage);
                if (this.constants.PRESET_ROWS_PER_PAGE.includes(dfRowsPerPage)) {
                    this.paging.rowPerPage = dfRowsPerPage;
                } else {
                    this.paging.rowPerPage = 10;
                }
            },
            changeCmplStatFilter() {
                this.paging.currentPage = 1;
                this.slctPlcyList();
            },
            setRowsPerPage(rpp) {
                this.paging.rowPerPage = rpp.rowsPerPage;
                this.paging.currentPage = rpp.currentPage;
                this.debounceSlctPlcyList();
            },
            setCurrentPage(e) {
                this.paging.currentPage = e;
                this.slctPlcyList();
            },
            slctPlcyList: function(refresh) {
                if(!refresh) {
                    this.pending = true
                }
                let url = `/api/governance/policy/system/list`;
                let header = {
                    'cmpnId':       this.curCmpnId,
                    'userDefiYn':   'N',
                    'srchText':     this.search.srchText,
                    'rowPerPage':   this.paging.rowPerPage,
                    'currentPage':  this.paging.currentPage,
                    'sortOrder':    this.sortOrder,
                    'sortColumn':   this.sortColumn,
                    'isLimitPage':  true,
                    'statusFilter': this.cmplStatFilter
                };

                this.http.post(url, JSON.stringify(header))
                    .then( response => {
                        this.plcyList = response.data.result;
                        this.paging = response.data.pagination;
                        this.pending = false
                    });
            },
            fnSearching: function() {
                this.paging.currentPage = 1;
                this.slctPlcyList(false);
            },
            setSortColumn: function (sortColumn) {
                if (this.sortColumn !== sortColumn) {
                    this.sortColumn = sortColumn;
                    this.sortOrder = 'asc';
                } else if (this.sortColumn === sortColumn && this.sortOrder === 'asc') {
                    this.sortOrder = 'desc'
                } else if (this.sortColumn === sortColumn && this.sortOrder === 'desc') {
                    this.sortColumn = '';
                    this.sortOrder = '';
                }
                this.slctPlcyList();
            },
            // 새 Policy 등록
            insertGovernancePolicy: function (){
                this.pending = true;
                // reset currentPage
                this.paging.currentPage = 1;
                this.newPlcy.cmpnId = this.curCmpnId;
                this.newPlcy[this.$i18n.locale+"Title"] = this.newPlcy.titl;
                this.newPlcy[this.$i18n.locale+"Desc"] = this.newPlcy.desc;
                let url = `/api/governance/policy/system`;
                this.http.post(url, JSON.stringify(this.newPlcy))
                    .then( result => {
                        if(result.data.status === 'ok'){
                            this.slctPlcyList();
                            this.$nextTick(function() {
                                // newPlcy 초기화 및 Popup 닫기
                                this.newPlcy = {};
                                $.magnificPopup.close();
                                EventBus.$emit('toastComment', 'POLICY.TOAST.CREATED_POLICY');
                            });
                        } else if(result.data.status === 'fail' && result.data.error.message === 'ERROR_D'){
                            // 타이틀 중복 처리
                            this.duplicateNewPolicyTitle = true
                            this.pending = false;
                        }
                    });
            },
            convertUtcTimezoneToLocal: function(date) {
                return this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale);
            },
            // Policy 삭제
            deletePolicy(plcy, event) {

                $('[data-icon=more]').removeAttr('data-show');

                this.Common.setConfirmBtnCustom(
                    this.$t('POLICY.LABEL.DEL_POLICY'),
                    plcy.cmplStat === 'R' ? this.$t('POLICY.DEL_POPUP.DESC_BEING_EVALUATED') : plcy.cmplId !== null ? this.$t('POLICY.DEL_POPUP.DESC_INCLUDED_COMPLIANCE') : this.$t('POLICY.DEL_POPUP.DESC'),
                    this.$t('COMMON.BUTTON.CAMEL.CANCEL'),
                    this.$t('COMMON.BUTTON.CAMEL.OK'), (result)=>{
                    if(result){
                        this.pending = true;
                        let header = {
                            'cmpnId': plcy.cmpnId,
                            'plcyId': plcy.plcyId,
                            'rvsnId': plcy.rvsnId
                        };

                        let url = `/api/governance/policy/delete`;
                        this.http.post(url, JSON.stringify(header))
                            .then( response => {
                                if(response.data.status === 'ok') {
                                    this.pending = false;
                                    this.slctPlcyList(false);
                                }
                            });
                    }
                })
            },
            goToHistory(plcy){
                const url = '/audit/detail';
                this.$router.push({path: url, query: {plcy: plcy.plcyId}});
            },
            // Policy 상세 화면으로 이동
            moveToDetail(plcy, $event) {
                if($event.target.nodeName !== 'BUTTON'){
                    const url = "/policy/mng/system/detail"
                    this.$router.push({path: url, query: {rvsn: plcy.rvsnId}});
                }
            },
            // Policy 복제 화면으로 이동
            moveToReplica(plcy) {
                const url = "/policy/replica"
                this.$router.push({path: url, query: {rvsn: plcy.rvsnId}});
            },
            closePopup() {
                this.Common.closePopup();
            },
            openAddSchePopup: function (plcy, popupId) {
                this.tmpPlcy = plcy;
                this.rKey++;
                this.$nextTick(function(){
                    this.Common.viewPopup(popupId)
                })
            },
            openAddPlcyPopup: function(popupId) {
                this.newPlcy = {
                    titl : '',
                    desc : ''
                };
                this.rKey++;
                this.Common.viewPopup(popupId);
            },
            closeInsertPolicyPopup: function() {
                this.invalidNewPolicyTitle = false;
                this.newPlcy = {};
                this.Common.closePopup();
            },

            // TODO :: Text Message 만 나오는 Policy Title 유효성 검사
            isInvalidPolicyTitle() {
                if (this.Common.isEmptyText(this.newPlcy.titl)) {
                    this.invalidNewPolicyTitle = true;
                } else {
                    this.invalidNewPolicyTitle = false;
                }
                return this.invalidNewPolicyTitle;
            },
//            changeSchedule($event){
//                var url = `/api/governance/policy/apply`;
//
//                var data = {
//                    'cmpnId': this.$store.state.loginUser.curCmpnId,
//                    'plcyId': this.tmpPlcy.plcyId,
//                    'rvsnId': this.tmpPlcy.rvsnId,
//                    'cmplId': this.tmpPlcy.cmplId
//                };
//                data.scheInfo = $event;
//
//                this.http.post(url, JSON.stringify(data))
//                    .then(result => {
//                        if(result.data.status === 'ok'){
//                            this.Common.closePopup();
//                        }
//                    });
//            }
//            ,
            addPolicyToCompliance($event) {

                if(this.pending) return;

                this.pending = true;
                let data = {
                    'cmpnId': this.$store.state.loginUser.curCmpnId,
                    'plcyId': this.tmpPlcy.plcyId,
                    'rvsnId': this.tmpPlcy.rvsnId,
                    'cmplId': this.tmpPlcy.cmplId,
                    'doCmpl' : $event.doCmpl
                };

                if($event.execType && $event.execType==='A'){
                    data.execType=$event.execType;
                    data.scheInfo=$event.scheInfo
                }

                let url = `/api/governance/policy/apply`;
                this.http.post(url, data)
                    .then( response => {
                        if(response.data.status === 'ok'){
                            this.slctPlcyList($event.doCmpl);
                            this.pending = false;
                            this.closePopup();
                        }
                    });

                if($event.doCmpl) {
                    this.changeStatExaming(this.tmpPlcy.plcyId);
                    this.autoRefresh();
                    this.pending = false;
                    this.closePopup();
                }
                // this.plcyList = response.data.result;



                EventBus.$emit('addPolicyToCompliance');
            },
            // setManagementOptions: function() {
            //     var $moreActions = $('[data-trigger="management"]');
            //     $moreActions.tooltipster({
            //         animation: 'fade',
            //         side: 'bottom',
            //         //contentCloning :  true,
            //         theme: 'go-actions',
            //         interactive: true,
            //         trigger: 'click',
            //         arrow: false,
            //         functionBefore: function(instance, helper) {
            //             $(helper.origin).addClass("selected");
            //         },
            //         functionAfter: function(instance, helper) {
            //             $(helper.origin).removeClass("selected");
            //         },
            //         functionPosition: function(instance, helper, position) {
            //             position.coord.top -= 7;
            //             position.coord.left = helper.geo.origin.offset.right - position.size.width;
            //             return position;
            //         }
            //     });
            // },
            initMultiFilter: function() {

                let $filterTarget = $('.tbl-collapse .buttons-tbl-header[data-type=filter]')

                $filterTarget.tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-filter',
                    interactive: true,
                    trigger: 'click',
                    functionBefore: function(instance, helper) {
                        $(helper.origin).addClass("selected");
                    },
                    functionAfter: function(instance, helper) {
                        $(helper.origin).removeClass("selected");
                    },
                    functionPosition: function(instance, helper, position) {
                        position.coord.top -= 7;
                        position.coord.left = helper.geo.origin.offset.right - position.size.width;
                        return position;
                    }
                });
            },
            toggleManagement: function(event){
                $(event.target).toggleAttr('data-show', '')
            },
            hideManagement: function(event){
                $(event.target).removeAttr('data-show');
            },
            changeStatExaming: function(plcyId){
                let self = this
                _.find(this.plcyList, function(o){
                    o.plcyId == plcyId ? o.cmplStat = self.constants.COMPLIANCE_STAT.EXAMINING : false
                })
            },
            autoRefresh: function(){
                const self = this;
                setTimeout(function () {
                    self.slctPlcyList(true)
                }, 5000)
            },
            toggleHelp: function(){
                EventBus.$emit('toggleViewPolicyHelp')
            }
        }
    }
</script>

<style scoped>
.custom-pagination.-pagination {
    right: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/bestpractice/systempolicy.vue